module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "spinner-demo",
    attrs: {
      "title": "Spinner"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "left"
  }, [_c('Spinner', {
    attrs: {
      "color": 'pink'
    }
  }), _vm._v(" "), _c('Spinner', {
    attrs: {
      "color": '#87db83'
    }
  }), _vm._v(" "), _c('Spinner', {
    attrs: {
      "color": 'rgba(255, 66, 66, 1)'
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "size",
      "description": "尺寸",
      "code": _vm.size_code
    },
    slot: "right"
  }, [_c('Spinner'), _vm._v(" "), _c('Spinner', {
    attrs: {
      "size": 36
    }
  }), _vm._v(" "), _c('Spinner', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('Spinner', {
    attrs: {
      "size": 60
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "wrap",
      "description": "覆盖整个容器, 基于最近的定位父级`relative`",
      "code": _vm.wrap_code
    },
    slot: "left"
  }, [_c('article', {
    staticClass: "article"
  }, [_c('h3', [_vm._v("Article Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test text")]), _vm._v(" "), _c('Spinner', {
    attrs: {
      "wrap": true
    }
  }, [_vm._v("\n        Loading...\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-630008f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Spinner.vue
// module id = 666
// module chunks = 0